export interface PlatformModel {
  label: string;
  value: string;
}

export enum Platforms {
    
}
